// extracted by mini-css-extract-plugin
export default {"container":"Bk-z","blurb":"Ck-z","links":"Dk-z"};